import { render, staticRenderFns } from "./data30.vue?vue&type=template&id=e24ceaba&scoped=true"
import script from "./data30.vue?vue&type=script&lang=js"
export * from "./data30.vue?vue&type=script&lang=js"
import style1 from "./data30.vue?vue&type=style&index=1&id=e24ceaba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24ceaba",
  null
  
)

export default component.exports